module.exports = __webpack_public_path__ + "static/media/trash.cb33f4f1.png";